import { ActivityProgress, ActivityType, MinimalActivity } from './activity';
import { Communication } from './course-communication';
import { User } from './my-account';
import { PointsConfiguration } from './points-configuration';

export interface PollOption {
  id: number;
  optionContent: string;
  votesCount: number;
  voters: User[];
}

export interface PollOptionNormalized extends Omit<PollOption, 'voters'> {
  voterIds: number[];
}

export interface PollOptionsNormalizedDictionary {
  [k: number]: PollOptionNormalized;
}

export enum PollQuestionType {
  MULTIPLE_CHOICE = 'MultipleChoiceQuestion',
  MULTIPLE_CHOICE_MULTIPLE_ANSWER = 'MultipleChoiceMultipleAnswerQuestion',
}

export interface PollQuestion {
  id: number;
  type: PollQuestionType;
  questionText: string;
  responseOptions: PollOptionNormalized[];
}

export interface PollQuestionNormalized extends Omit<PollQuestion, 'responseOptions'> {
  responseOptionIds: number[];
}

export interface PollQuestionsNormalizedDictionary {
  [k: number]: PollQuestionNormalized;
}

export interface PollVieweeSubmission {
  type: 'questionsetsubmission';
  id: number;
  pointsReceived: number | null;
  priorLeaderboardRank: number | null;
  leaderboardPoints: number;
  leaderboardRank: number | null;
  questions: [PollQuestion];
  responses: [
    {
      response: number;
    },
  ];
}

export interface PollVieweeSubmissionNormalized extends Omit<PollVieweeSubmission, 'questions'> {
  questionIds: [number];
}

export interface PollVieweeSubmissionNormalizedDirectory {
  [k: number]: PollVieweeSubmissionNormalized;
}

export interface MinimalPoll extends MinimalActivity {
  type: ActivityType.POLL;
}
export interface Poll extends MinimalPoll {
  questions: [PollQuestion];
  pointsConfiguration?: PointsConfiguration;
  isTodo: boolean;
  expirationDate: string | null;
  hardDeadline: boolean;
  responsePrivacySetting: 'social' | 'anonymous';
  vieweeSubmission: null | PollVieweeSubmission;
  progress: ActivityProgress;
  communicationsCount?: number;
  communications: Communication;
  catalogId: string;
  courseCatalogId: string,
  courseId: number;
  lecturePageId: number;
  lectureComponentId: number;
}

export interface PollNormalized
  extends Omit<Poll, 'questions' | 'pointsConfiguration' | 'vieweeSubmission' | 'communications'> {
  questionIds: [number];
  pointsConfigurationId?: number;
  vieweeSubmissionId?: number;
  communications: number[];
  learnerStartedSubmission: boolean;
}

export interface PollsNormalizedDictionary {
  [k: number]: PollNormalized;
}
